import { c as ft, a as dt } from "./@popperjs_core@2.11.8.js";
var lt = "tippy-content", vt = "tippy-backdrop", mt = "tippy-arrow", gt = "tippy-svg-arrow", x = {
  passive: !0,
  capture: !0
}, Fe = function() {
  return document.body;
};
function ht(e, i) {
  return {}.hasOwnProperty.call(e, i);
}
function re(e, i, r) {
  if (Array.isArray(e)) {
    var a = e[i];
    return a ?? (Array.isArray(r) ? r[i] : r);
  }
  return e;
}
function pe(e, i) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(i + "]") > -1;
}
function We(e, i) {
  return typeof e == "function" ? e.apply(void 0, i) : e;
}
function Ve(e, i) {
  if (i === 0)
    return e;
  var r;
  return function(a) {
    clearTimeout(r), r = setTimeout(function() {
      e(a);
    }, i);
  };
}
function yt(e, i) {
  var r = Object.assign({}, e);
  return i.forEach(function(a) {
    delete r[a];
  }), r;
}
function bt(e) {
  return e.split(/\s+/).filter(Boolean);
}
function I(e) {
  return [].concat(e);
}
function Ie(e, i) {
  e.indexOf(i) === -1 && e.push(i);
}
function Et(e) {
  return e.filter(function(i, r) {
    return e.indexOf(i) === r;
  });
}
function Tt(e) {
  return e.split("-")[0];
}
function G(e) {
  return [].slice.call(e);
}
function Me(e) {
  return Object.keys(e).reduce(function(i, r) {
    return e[r] !== void 0 && (i[r] = e[r]), i;
  }, {});
}
function Ot() {
  return document.createElement("div");
}
function ue(e) {
  return ["Element", "Fragment"].some(function(i) {
    return pe(e, i);
  });
}
function Dt(e) {
  return pe(e, "NodeList");
}
function wt(e) {
  return pe(e, "MouseEvent");
}
function At(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function St(e) {
  return ue(e) ? [e] : Dt(e) ? G(e) : Array.isArray(e) ? e : G(document.querySelectorAll(e));
}
function oe(e, i) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = i + "ms");
  });
}
function je(e, i) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", i);
  });
}
function Lt(e) {
  var i, r = I(e), a = r[0];
  return a != null && (i = a.ownerDocument) != null && i.body ? a.ownerDocument : document;
}
function xt(e, i) {
  var r = i.clientX, a = i.clientY;
  return e.every(function(d) {
    var f = d.popperRect, l = d.popperState, h = d.props, E = h.interactiveBorder, T = Tt(l.placement), m = l.modifiersData.offset;
    if (!m)
      return !0;
    var k = T === "bottom" ? m.top.y : 0, B = T === "top" ? m.bottom.y : 0, M = T === "right" ? m.left.x : 0, w = T === "left" ? m.right.x : 0, F = f.top - a + k > E, J = a - f.bottom - B > E, Q = f.left - r + M > E, W = r - f.right - w > E;
    return F || J || Q || W;
  });
}
function ae(e, i, r) {
  var a = i + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(d) {
    e[a](d, r);
  });
}
function _e(e, i) {
  for (var r = i; r; ) {
    var a;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (a = r.getRootNode()) == null ? void 0 : a.host;
  }
  return !1;
}
var D = {
  isTouch: !1
}, Re = 0;
function Nt() {
  D.isTouch || (D.isTouch = !0, window.performance && document.addEventListener("mousemove", He));
}
function He() {
  var e = performance.now();
  e - Re < 20 && (D.isTouch = !1, document.removeEventListener("mousemove", He)), Re = e;
}
function Ct() {
  var e = document.activeElement;
  if (At(e)) {
    var i = e._tippy;
    e.blur && !i.state.isVisible && e.blur();
  }
}
function Pt() {
  document.addEventListener("touchstart", Nt, x), window.addEventListener("blur", Ct);
}
var Vt = typeof window < "u" && typeof document < "u", It = Vt ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function V(e) {
  var i = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + i + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Ue(e) {
  var i = /[ \t]{2,}/g, r = /^[ \t]*/gm;
  return e.replace(i, " ").replace(r, "").trim();
}
function Mt(e) {
  return Ue(`
  %ctippy.js

  %c` + Ue(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function $e(e) {
  return [
    Mt(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var U;
process.env.NODE_ENV !== "production" && jt();
function jt() {
  U = /* @__PURE__ */ new Set();
}
function A(e, i) {
  if (e && !U.has(i)) {
    var r;
    U.add(i), (r = console).warn.apply(r, $e(i));
  }
}
function ce(e, i) {
  if (e && !U.has(i)) {
    var r;
    U.add(i), (r = console).error.apply(r, $e(i));
  }
}
function _t(e) {
  var i = !e, r = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  ce(i, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), ce(r, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var ze = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Rt = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, g = Object.assign({
  appendTo: Fe,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, ze, Rt), Ut = Object.keys(g), kt = function(i) {
  process.env.NODE_ENV !== "production" && Ye(i, []);
  var r = Object.keys(i);
  r.forEach(function(a) {
    g[a] = i[a];
  });
};
function qe(e) {
  var i = e.plugins || [], r = i.reduce(function(a, d) {
    var f = d.name, l = d.defaultValue;
    if (f) {
      var h;
      a[f] = e[f] !== void 0 ? e[f] : (h = g[f]) != null ? h : l;
    }
    return a;
  }, {});
  return Object.assign({}, e, r);
}
function Bt(e, i) {
  var r = i ? Object.keys(qe(Object.assign({}, g, {
    plugins: i
  }))) : Ut, a = r.reduce(function(d, f) {
    var l = (e.getAttribute("data-tippy-" + f) || "").trim();
    if (!l)
      return d;
    if (f === "content")
      d[f] = l;
    else
      try {
        d[f] = JSON.parse(l);
      } catch {
        d[f] = l;
      }
    return d;
  }, {});
  return a;
}
function ke(e, i) {
  var r = Object.assign({}, i, {
    content: We(i.content, [e])
  }, i.ignoreAttributes ? {} : Bt(e, i.plugins));
  return r.aria = Object.assign({}, g.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? i.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? i.interactive ? null : "describedby" : r.aria.content
  }, r;
}
function Ye(e, i) {
  e === void 0 && (e = {}), i === void 0 && (i = []);
  var r = Object.keys(e);
  r.forEach(function(a) {
    var d = yt(g, Object.keys(ze)), f = !ht(d, a);
    f && (f = i.filter(function(l) {
      return l.name === a;
    }).length === 0), A(f, ["`" + a + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
function Be(e) {
  var i = e.firstElementChild, r = G(i.children);
  return {
    box: i,
    content: r.find(function(a) {
      return a.classList.contains(lt);
    }),
    arrow: r.find(function(a) {
      return a.classList.contains(mt) || a.classList.contains(gt);
    }),
    backdrop: r.find(function(a) {
      return a.classList.contains(vt);
    })
  };
}
var Ft = 1, K = [], se = [];
function Wt(e, i) {
  var r = ke(e, Object.assign({}, g, qe(Me(i)))), a, d, f, l = !1, h = !1, E = !1, T = !1, m, k, B, M = [], w = Ve(we, r.interactiveDebounce), F, J = Ft++, Q = null, W = Et(r.plugins), Ke = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, t = {
    // properties
    id: J,
    reference: e,
    popper: Ot(),
    popperInstance: Q,
    props: r,
    state: Ke,
    plugins: W,
    // methods
    clearDelayTimeouts: nt,
    setProps: it,
    setContent: rt,
    show: ot,
    hide: at,
    hideWithInteractivity: st,
    enable: et,
    disable: tt,
    unmount: ut,
    destroy: ct
  };
  if (!r.render)
    return process.env.NODE_ENV !== "production" && ce(!0, "render() function has not been supplied."), t;
  var fe = r.render(t), c = fe.popper, de = fe.onUpdate;
  c.setAttribute("data-tippy-root", ""), c.id = "tippy-" + t.id, t.popper = c, e._tippy = t, c._tippy = t;
  var Ge = W.map(function(n) {
    return n.fn(t);
  }), Xe = e.hasAttribute("aria-expanded");
  return Te(), R(), H(), y("onCreate", [t]), r.showOnCreate && Ce(), c.addEventListener("mouseenter", function() {
    t.props.interactive && t.state.isVisible && t.clearDelayTimeouts();
  }), c.addEventListener("mouseleave", function() {
    t.props.interactive && t.props.trigger.indexOf("mouseenter") >= 0 && j().addEventListener("mousemove", w);
  }), t;
  function le() {
    var n = t.props.touch;
    return Array.isArray(n) ? n : [n, 0];
  }
  function ve() {
    return le()[0] === "hold";
  }
  function O() {
    var n;
    return !!((n = t.props.render) != null && n.$$tippy);
  }
  function S() {
    return F || e;
  }
  function j() {
    var n = S().parentNode;
    return n ? Lt(n) : document;
  }
  function _() {
    return Be(c);
  }
  function me(n) {
    return t.state.isMounted && !t.state.isVisible || D.isTouch || m && m.type === "focus" ? 0 : re(t.props.delay, n ? 0 : 1, g.delay);
  }
  function H(n) {
    n === void 0 && (n = !1), c.style.pointerEvents = t.props.interactive && !n ? "" : "none", c.style.zIndex = "" + t.props.zIndex;
  }
  function y(n, o, s) {
    if (s === void 0 && (s = !0), Ge.forEach(function(u) {
      u[n] && u[n].apply(u, o);
    }), s) {
      var p;
      (p = t.props)[n].apply(p, o);
    }
  }
  function ge() {
    var n = t.props.aria;
    if (n.content) {
      var o = "aria-" + n.content, s = c.id, p = I(t.props.triggerTarget || e);
      p.forEach(function(u) {
        var v = u.getAttribute(o);
        if (t.state.isVisible)
          u.setAttribute(o, v ? v + " " + s : s);
        else {
          var b = v && v.replace(s, "").trim();
          b ? u.setAttribute(o, b) : u.removeAttribute(o);
        }
      });
    }
  }
  function R() {
    if (!(Xe || !t.props.aria.expanded)) {
      var n = I(t.props.triggerTarget || e);
      n.forEach(function(o) {
        t.props.interactive ? o.setAttribute("aria-expanded", t.state.isVisible && o === S() ? "true" : "false") : o.removeAttribute("aria-expanded");
      });
    }
  }
  function Z() {
    j().removeEventListener("mousemove", w), K = K.filter(function(n) {
      return n !== w;
    });
  }
  function $(n) {
    if (!(D.isTouch && (E || n.type === "mousedown"))) {
      var o = n.composedPath && n.composedPath()[0] || n.target;
      if (!(t.props.interactive && _e(c, o))) {
        if (I(t.props.triggerTarget || e).some(function(s) {
          return _e(s, o);
        })) {
          if (D.isTouch || t.state.isVisible && t.props.trigger.indexOf("click") >= 0)
            return;
        } else
          y("onClickOutside", [t, n]);
        t.props.hideOnClick === !0 && (t.clearDelayTimeouts(), t.hide(), h = !0, setTimeout(function() {
          h = !1;
        }), t.state.isMounted || ee());
      }
    }
  }
  function he() {
    E = !0;
  }
  function ye() {
    E = !1;
  }
  function be() {
    var n = j();
    n.addEventListener("mousedown", $, !0), n.addEventListener("touchend", $, x), n.addEventListener("touchstart", ye, x), n.addEventListener("touchmove", he, x);
  }
  function ee() {
    var n = j();
    n.removeEventListener("mousedown", $, !0), n.removeEventListener("touchend", $, x), n.removeEventListener("touchstart", ye, x), n.removeEventListener("touchmove", he, x);
  }
  function Je(n, o) {
    Ee(n, function() {
      !t.state.isVisible && c.parentNode && c.parentNode.contains(c) && o();
    });
  }
  function Qe(n, o) {
    Ee(n, o);
  }
  function Ee(n, o) {
    var s = _().box;
    function p(u) {
      u.target === s && (ae(s, "remove", p), o());
    }
    if (n === 0)
      return o();
    ae(s, "remove", k), ae(s, "add", p), k = p;
  }
  function N(n, o, s) {
    s === void 0 && (s = !1);
    var p = I(t.props.triggerTarget || e);
    p.forEach(function(u) {
      u.addEventListener(n, o, s), M.push({
        node: u,
        eventType: n,
        handler: o,
        options: s
      });
    });
  }
  function Te() {
    ve() && (N("touchstart", De, {
      passive: !0
    }), N("touchend", Ae, {
      passive: !0
    })), bt(t.props.trigger).forEach(function(n) {
      if (n !== "manual")
        switch (N(n, De), n) {
          case "mouseenter":
            N("mouseleave", Ae);
            break;
          case "focus":
            N(It ? "focusout" : "blur", Se);
            break;
          case "focusin":
            N("focusout", Se);
            break;
        }
    });
  }
  function Oe() {
    M.forEach(function(n) {
      var o = n.node, s = n.eventType, p = n.handler, u = n.options;
      o.removeEventListener(s, p, u);
    }), M = [];
  }
  function De(n) {
    var o, s = !1;
    if (!(!t.state.isEnabled || Le(n) || h)) {
      var p = ((o = m) == null ? void 0 : o.type) === "focus";
      m = n, F = n.currentTarget, R(), !t.state.isVisible && wt(n) && K.forEach(function(u) {
        return u(n);
      }), n.type === "click" && (t.props.trigger.indexOf("mouseenter") < 0 || l) && t.props.hideOnClick !== !1 && t.state.isVisible ? s = !0 : Ce(n), n.type === "click" && (l = !s), s && !p && z(n);
    }
  }
  function we(n) {
    var o = n.target, s = S().contains(o) || c.contains(o);
    if (!(n.type === "mousemove" && s)) {
      var p = te().concat(c).map(function(u) {
        var v, b = u._tippy, C = (v = b.popperInstance) == null ? void 0 : v.state;
        return C ? {
          popperRect: u.getBoundingClientRect(),
          popperState: C,
          props: r
        } : null;
      }).filter(Boolean);
      xt(p, n) && (Z(), z(n));
    }
  }
  function Ae(n) {
    var o = Le(n) || t.props.trigger.indexOf("click") >= 0 && l;
    if (!o) {
      if (t.props.interactive) {
        t.hideWithInteractivity(n);
        return;
      }
      z(n);
    }
  }
  function Se(n) {
    t.props.trigger.indexOf("focusin") < 0 && n.target !== S() || t.props.interactive && n.relatedTarget && c.contains(n.relatedTarget) || z(n);
  }
  function Le(n) {
    return D.isTouch ? ve() !== n.type.indexOf("touch") >= 0 : !1;
  }
  function xe() {
    Ne();
    var n = t.props, o = n.popperOptions, s = n.placement, p = n.offset, u = n.getReferenceClientRect, v = n.moveTransition, b = O() ? Be(c).arrow : null, C = u ? {
      getBoundingClientRect: u,
      contextElement: u.contextElement || S()
    } : e, Pe = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(q) {
        var P = q.state;
        if (O()) {
          var pt = _(), ie = pt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Y) {
            Y === "placement" ? ie.setAttribute("data-placement", P.placement) : P.attributes.popper["data-popper-" + Y] ? ie.setAttribute("data-" + Y, "") : ie.removeAttribute("data-" + Y);
          }), P.attributes.popper = {};
        }
      }
    }, L = [{
      name: "offset",
      options: {
        offset: p
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !v
      }
    }, Pe];
    O() && b && L.push({
      name: "arrow",
      options: {
        element: b,
        padding: 3
      }
    }), L.push.apply(L, (o == null ? void 0 : o.modifiers) || []), t.popperInstance = ft(C, c, Object.assign({}, o, {
      placement: s,
      onFirstUpdate: B,
      modifiers: L
    }));
  }
  function Ne() {
    t.popperInstance && (t.popperInstance.destroy(), t.popperInstance = null);
  }
  function Ze() {
    var n = t.props.appendTo, o, s = S();
    t.props.interactive && n === Fe || n === "parent" ? o = s.parentNode : o = We(n, [s]), o.contains(c) || o.appendChild(c), t.state.isMounted = !0, xe(), process.env.NODE_ENV !== "production" && A(t.props.interactive && n === g.appendTo && s.nextElementSibling !== c, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function te() {
    return G(c.querySelectorAll("[data-tippy-root]"));
  }
  function Ce(n) {
    t.clearDelayTimeouts(), n && y("onTrigger", [t, n]), be();
    var o = me(!0), s = le(), p = s[0], u = s[1];
    D.isTouch && p === "hold" && u && (o = u), o ? a = setTimeout(function() {
      t.show();
    }, o) : t.show();
  }
  function z(n) {
    if (t.clearDelayTimeouts(), y("onUntrigger", [t, n]), !t.state.isVisible) {
      ee();
      return;
    }
    if (!(t.props.trigger.indexOf("mouseenter") >= 0 && t.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(n.type) >= 0 && l)) {
      var o = me(!1);
      o ? d = setTimeout(function() {
        t.state.isVisible && t.hide();
      }, o) : f = requestAnimationFrame(function() {
        t.hide();
      });
    }
  }
  function et() {
    t.state.isEnabled = !0;
  }
  function tt() {
    t.hide(), t.state.isEnabled = !1;
  }
  function nt() {
    clearTimeout(a), clearTimeout(d), cancelAnimationFrame(f);
  }
  function it(n) {
    if (process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("setProps")), !t.state.isDestroyed) {
      y("onBeforeUpdate", [t, n]), Oe();
      var o = t.props, s = ke(e, Object.assign({}, o, Me(n), {
        ignoreAttributes: !0
      }));
      t.props = s, Te(), o.interactiveDebounce !== s.interactiveDebounce && (Z(), w = Ve(we, s.interactiveDebounce)), o.triggerTarget && !s.triggerTarget ? I(o.triggerTarget).forEach(function(p) {
        p.removeAttribute("aria-expanded");
      }) : s.triggerTarget && e.removeAttribute("aria-expanded"), R(), H(), de && de(o, s), t.popperInstance && (xe(), te().forEach(function(p) {
        requestAnimationFrame(p._tippy.popperInstance.forceUpdate);
      })), y("onAfterUpdate", [t, n]);
    }
  }
  function rt(n) {
    t.setProps({
      content: n
    });
  }
  function ot() {
    process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("show"));
    var n = t.state.isVisible, o = t.state.isDestroyed, s = !t.state.isEnabled, p = D.isTouch && !t.props.touch, u = re(t.props.duration, 0, g.duration);
    if (!(n || o || s || p) && !S().hasAttribute("disabled") && (y("onShow", [t], !1), t.props.onShow(t) !== !1)) {
      if (t.state.isVisible = !0, O() && (c.style.visibility = "visible"), H(), be(), t.state.isMounted || (c.style.transition = "none"), O()) {
        var v = _(), b = v.box, C = v.content;
        oe([b, C], 0);
      }
      B = function() {
        var L;
        if (!(!t.state.isVisible || T)) {
          if (T = !0, c.offsetHeight, c.style.transition = t.props.moveTransition, O() && t.props.animation) {
            var ne = _(), q = ne.box, P = ne.content;
            oe([q, P], u), je([q, P], "visible");
          }
          ge(), R(), Ie(se, t), (L = t.popperInstance) == null || L.forceUpdate(), y("onMount", [t]), t.props.animation && O() && Qe(u, function() {
            t.state.isShown = !0, y("onShown", [t]);
          });
        }
      }, Ze();
    }
  }
  function at() {
    process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("hide"));
    var n = !t.state.isVisible, o = t.state.isDestroyed, s = !t.state.isEnabled, p = re(t.props.duration, 1, g.duration);
    if (!(n || o || s) && (y("onHide", [t], !1), t.props.onHide(t) !== !1)) {
      if (t.state.isVisible = !1, t.state.isShown = !1, T = !1, l = !1, O() && (c.style.visibility = "hidden"), Z(), ee(), H(!0), O()) {
        var u = _(), v = u.box, b = u.content;
        t.props.animation && (oe([v, b], p), je([v, b], "hidden"));
      }
      ge(), R(), t.props.animation ? O() && Je(p, t.unmount) : t.unmount();
    }
  }
  function st(n) {
    process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("hideWithInteractivity")), j().addEventListener("mousemove", w), Ie(K, w), w(n);
  }
  function ut() {
    process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("unmount")), t.state.isVisible && t.hide(), t.state.isMounted && (Ne(), te().forEach(function(n) {
      n._tippy.unmount();
    }), c.parentNode && c.parentNode.removeChild(c), se = se.filter(function(n) {
      return n !== t;
    }), t.state.isMounted = !1, y("onHidden", [t]));
  }
  function ct() {
    process.env.NODE_ENV !== "production" && A(t.state.isDestroyed, V("destroy")), !t.state.isDestroyed && (t.clearDelayTimeouts(), t.unmount(), Oe(), delete e._tippy, t.state.isDestroyed = !0, y("onDestroy", [t]));
  }
}
function X(e, i) {
  i === void 0 && (i = {});
  var r = g.plugins.concat(i.plugins || []);
  process.env.NODE_ENV !== "production" && (_t(e), Ye(i, r)), Pt();
  var a = Object.assign({}, i, {
    plugins: r
  }), d = St(e);
  if (process.env.NODE_ENV !== "production") {
    var f = ue(a.content), l = d.length > 1;
    A(f && l, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var h = d.reduce(function(E, T) {
    var m = T && Wt(T, a);
    return m && E.push(m), E;
  }, []);
  return ue(e) ? h[0] : h;
}
X.defaultProps = g;
X.setDefaultProps = kt;
X.currentInput = D;
Object.assign({}, dt, {
  effect: function(i) {
    var r = i.state, a = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, a.popper), r.styles = a, r.elements.arrow && Object.assign(r.elements.arrow.style, a.arrow);
  }
});
X.setDefaultProps({
  animation: !1
});
export {
  X as t
};
